import { Stack, Switch, Text } from "@chakra-ui/react";

type Props = {
  title?: string;
  isChecked: boolean;
  onChange: (value: boolean) => void;
};

function ToggleSwitch({ title, isChecked, onChange }: Props) {
  return (
    <Stack direction="row" data-testid="toggle-switch" alignItems="center">
      <Switch
        data-testid="switch-element"
        id="switch-element"
        size="sm"
        sx={{
          ".chakra-switch__track[data-checked]": { background: "blue.400" },
        }}
        isChecked={isChecked}
        onChange={e => onChange(e.target.checked)}
      />
      {title && <Text data-testid="switch-title">{title}</Text>}
    </Stack>
  );
}

export default ToggleSwitch;
